import {
  Component,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { EventEmitter } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import _get from 'lodash/get';
@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
})
export class PaginatorComponent implements OnChanges {
  @Input() readonly pageSize: number;
  @Input() readonly length: number;
  @Input() pageIndex: number;

  @Output() changePaginator = new EventEmitter();
  @ViewChild('paginator') paginator: MatPaginator;

  ngOnChanges(changes: SimpleChanges): void {
    const currentPageIndex: any = _get(changes, 'pageIndex.currentValue', 0);
    this.pageIndex = currentPageIndex - 1;
  }

  changedPaginator(event): void {
    this.changePaginator.emit(event);
  }

  setPaginator(pageNum): void {
    if (this.paginator) {
      this.paginator.pageIndex = pageNum;
    }
  }
}
